const topicKeys = {
    all: () => ['topics'],
    getTopic: (topicId: string) => ['topics', topicId],
    getTopicLabels: (topicId: string) => ['topics', topicId, 'labels'],
};

export default topicKeys;
